// DISPLAY CUSTOMIZABLE HEADER

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardMedia from '@material-ui/core/CardMedia';
//import Card from '@material-ui/core/CardMedia';
//import CardContent from '@material-ui/core/CardContent';
import Box from '@material-ui/core/Box';

import logo_shield from './fantes_md_shield.svg';

const useStyles = makeStyles((theme) => ({
    container: {
        alignItems: 'left',
    },
    card: {
        //padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
          //margin: theme.spacing(2),
          alignItems: 'center',
          maxWidth: 150,
      }, 
      cardText: {
        color: theme.palette.text.secondary,
        textAlign: 'left',
        alignItems: 'left',
      },
      media: {
          width: 100,
          //marginBottom: theme.spacing(4),
      },
      header1: {
        fontSize: 32,
        //fontFamily: 'Roboto',
      },
      header2: {
        fontSize: 22,
        //fontFamily: 'Roboto',
      },
  }));

export default function Headers(props) {

    const classes = useStyles();

    return <>
    <Grid container className={classes.container} spacing={3}>
        <Grid item> 
            <Box className={classes.card}>
                <CardMedia className={classes.media} image={logo_shield} component="img" alt="logo" />
            </Box>
        </Grid>
        <Grid item xs={8}>
            <Box className={classes.cardText}>
                <Typography className={classes.header1} variant="h1" color="inherit"><strong>{props.title}</strong></Typography> 
            </Box>
            <Box className={classes.cardText}>
                <Typography className={classes.header2} variant="h2" color="inherit">{props.subTitle}</Typography>
            </Box>
        </Grid>
    </Grid>
    </>;
}
